import typeahead from 'typeahead-standalone'
;(function () {
	const inputElement = document.getElementById('searchInput')
	const formElement = document.getElementById('ardent-provider-search')

	if (window.loyal_args) {
		typeahead({
			input: inputElement,
			source: {
				local: [],
				remote: {
					url:
						'https://api.loyalhealth.com/search/' +
						window.loyal_args.client_id +
						'/' +
						window.loyal_args.market_id +
						'/0/search/all/typeahead?searchText=%QUERY',
					wildcard: '%QUERY',
					requestOptions: {}, // optional, default => undefined
				},
				keys: ['displayName'], // optional (required when source => Object[])
				groupKey: 'sortType', // optional, default => undefined
				transform: data => {
					return data.entities.map(entity => {
						if ('provider' == entity.entityType) {
							entity.sortType = 'a'
						} else if ('specialty' === entity.entityType) {
							entity.sortType = 'b'
						} else {
							entity.sortType = 'c'
						}
						return entity
					})
				},
			},
			limit: 10,
			highlight: true,
			onSubmit: (e, selectedSuggestion) => {
				if (selectedSuggestion) {
					window.location.href =
						window.loyal_args.search_url + '/results?query=' + encodeURIComponent(selectedSuggestion)
				}
			},
			display: (item, event) => {
				if (event) {
					const directTypes = ['provider', 'location']
					if (item.entityType && directTypes.includes(item.entityType)) {
						window.location.href =
							window.loyal_args.search_url + '/' + item.entityType + '/' + item.entityId + '/'
					} else {
						window.location.href =
							window.loyal_args.search_url + '/results?query=' + encodeURIComponent(item.displayName)
					}
				}
				return item.displayName
			},
			templates: {
				group: groupName => {
					/* Used to render a group */
					var name = 'Clinical Terms'
					switch (groupName) {
						case 'a':
							name = 'Providers'
							break
						case 'b':
							name = 'Specialty'
							break
					}
					return `<div class="custom-group">${name}</div>`
				},
				suggestion: item => {
					/* Used to render a single suggestion */
					if (['provider', 'specialty'].includes(item.entityType)) {
						return `<div class="tt-suggestion ${item.entityType}">${item.displayName}<span class="tt-suggestion-alt">${item.details}</span></div>`
					} else {
						return `<div class="tt-suggestion">${item.displayName}</div>`
					}
				},
			},
		})
		jQuery(formElement).on('submit', function (e) {
			e.preventDefault()
			window.location.href =
				window.loyal_args.search_url + '/results?query=' + encodeURIComponent(jQuery(inputElement).val())
		})
	}
})()
